<template>
    <RedesignBasePopover
        v-model="visible"
        trigger="click"
        :visible-arrow="false"
        popper-class="base-menu-popover"
    >
        <template #reference>
            <div
                class="flex items-center justify-center"
            >
                <redesign-base-icon
                    :size="iconSize"
                    name="IconOptions"
                    class="flex items-center justify-center hover:text-active-elements--focus outline-none cursor-pointer"
                />
            </div>
        </template>
        <div
            :class="{'divide-y divide-ui-lines': divider}"
            class="base-menu-popover__menu"
        >
            <slot>
                <div
                    v-for="(menuItem, index) in menuItems"
                    :key="index"
                    class="menu-action_item cursor-pointer"
                    @click="menuItem.action"
                >
                    <div
                        class="flex items-center gap-2 p-2 hover:bg-primary-actions-bg--focus rounded transition-100"
                        :class="menuItem.menuItemClass"
                    >
                        <redesign-base-icon
                            v-if="menuItem.icon"
                            :name="menuItem.icon"
                            :size="18"
                            :class="menuItem.iconClass"
                            class="menu-action_item__icon"
                        />
                        <span
                            class="px-2 text-main-sm truncate"
                        >
                            {{ menuItem.label }}
                        </span>
                    </div>
                </div>
            </slot>
        </div>
    </RedesignBasePopover>
</template>

<script setup lang="ts">
import { defineProps, ref, withDefaults } from 'vue'
import RedesignBasePopover from '@/components/RedesignBaseComponents/RedesignBasePopover.vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'

type TBaseMenuitem = {
    label: string
    menuItemClass?: string
    icon?: string
    iconClass?: string
    action: () => void
}

withDefaults(
    defineProps<{
        iconSize?: number
        menuItems?: Array<TBaseMenuitem>
        divider?: boolean
    }>(),
    {
        iconSize: 16,
        menuItems: () => [],
        divider: true
    })

const visible = ref(false)
</script>
